module.exports = __webpack_public_path__ + "static/media/whichThinnerLowerRisk.5a330139.mp3";